import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect, useState } from "react";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import KryzenTop from "../Po-Dc-Pi-PDF-Tables/kryzen_Top";
import DeliveryDetails from "../Po-Dc-Pi-PDF-Tables/delivery_details";
import DeliveryList from "../Po-Dc-Pi-PDF-Tables/delivery_list";
import RecipientSignature from "../Po-Dc-Pi-PDF-Tables/delivery_recipient_signature";
import DeliveyChallanCondition from "../Po-Dc-Pi-PDF-Tables/delivey_challan_condition";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const PreviewDeliveryChallan = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [listData, setListData] = useState([]);
  const printPDF = () => {
    let name = "printPDF";
    document.title = name;
    window.print();
  };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/deliveryChallan/getDcById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          const dcStatus = res.data?.dcStatus || {};
          const originalLineItems = dcStatus?.lineItems || [];

          // ✅ Convert material items
          const materialItems =
            res.data?.materialData?.materialList
              ?.filter((item) => item?.count > 0)
              ?.map((item) => ({
                particulars: item?.item, // ✅ rename item → particulars
                itemQuantity: item?.count, // ✅ rename count → itemQuantity
                itemUnit: item?.unit, // ✅ keep same
              })) || [];

          // ✅ Update lineItems inside the object
          const finalData = {
            ...dcStatus,
            lineItems: [...originalLineItems, ...materialItems],
          };

          setData(finalData);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div
            className="page-header d-print-none"
            style={{ borderBottom: "1px solid #181818", marginBottom: "20px" }}
          >
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">Delivery Challan</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-auto ms-auto d-print-none">
                <div className="d-flex">
                  <SimpleButton buttonText={"Save Pdf"} onClick={printPDF} />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body" style={{ color: "black" }}>
            <KryzenTop />
            {data && <DeliveryDetails data={data} />}
            {<DeliveryList data={data?.lineItems} />}
            <RecipientSignature />
            <DeliveyChallanCondition />
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PreviewDeliveryChallan;
